export default __webpack_public_path__ + "static/media/square.5c92d9ea.svg";